<template>
  <el-dialog :close-on-click-modal="false" class="tx-c" :visible="visible" append-to-body :title="title" @close="cancel" width="50rem" top="10vh">
    <el-main style="padding: 10px; max-height: 35rem">
      <div v-loading="meta.loading">
        <div class="" style="padding:10px 20px;">
          <el-descriptions title="患者信息" :column="4" :colon="false">
            <el-descriptions-item label="姓名：">{{patient.patientName}}</el-descriptions-item>
            <el-descriptions-item label="性别：">{{patient.patientGender | dictText("Gender")}}</el-descriptions-item>
            <el-descriptions-item label="年龄：">{{patient.patientAge}}岁</el-descriptions-item>
            <el-descriptions-item label="医保类型：">{{patient.ipType}}</el-descriptions-item>
            <el-descriptions-item v-if="title=='预交金记录'" label="预交金总额：">{{patient.advanceFeeTotal || 0}}元</el-descriptions-item>
            <el-descriptions-item v-if="title=='预交金记录'" label="记账金额：">{{patient.bookkeepingFeeTotal || 0}}元</el-descriptions-item>

          </el-descriptions>
          <el-divider></el-divider>
          <el-descriptions :title="conTitle"></el-descriptions>
          <el-table v-if="title=='预交金记录'" :data="patient.depositList" style="width: 100%" border>
            <el-table-column label="凭据号" prop="payWaySerialNo"></el-table-column>
            <el-table-column label="类别" prop="paymentType"></el-table-column>
            <el-table-column label="方式" prop="">
              <template slot-scope="{ row }">
                <div>{{row.payWay | dictText("PayWay")}}</div> 
              </template>
            </el-table-column>
            <el-table-column label="金额(元)" prop="amount"></el-table-column>
            <el-table-column label="操作人" prop="ctUserName"></el-table-column>
            <el-table-column label="操作时间" prop="paymentDate"></el-table-column>
          </el-table>

          <el-form class="left" ref="info" :rules="rules" :inline="true" :model="detailValue" label-width="8rem">
            <el-row v-if="title=='欠账编辑' || title=='欠账详情'">
              <!-- <el-col :span="24">
                <el-form-item label="不交押金：" prop="">
                  <el-checkbox v-model="detailValue.checkedQZ" :disabled="title=='欠账详情'"></el-checkbox>
                </el-form-item>
              </el-col> -->
              <el-col v-if="!detailValue.checkedQZ" :span="12">
                <el-form-item label="欠账额度：" prop="qzAmount">
                  <el-input v-if="title=='欠账编辑'" v-model="detailValue.qzAmount" placeholder="请输入可欠账额度" size="small" clearable></el-input>
                  <div v-else>{{detailValue.qzAmount}}元</div>
                </el-form-item>
              </el-col>
              
              <el-col v-if="!detailValue.checkedQZ" :span="12">
                <el-form-item label="欠账截止日期：" prop="qzEndDate">
                  <el-date-picker v-if="title=='欠账编辑'"  size="small" style="width:210px;" v-model="detailValue.qzEndDate" type="date" placeholder="请选择欠账截止日期"></el-date-picker>
                  <div v-else>{{detailValue.qzEndDate}}元</div>
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注：" prop="">
                  <el-input v-if="title=='欠账编辑'" type="textarea" style="width:30rem;" maxlength="500" show-word-limit :autosize="{ minRows: 3, maxRows: 4}" placeholder="请输入备注" v-model="detailValue.memo"></el-input>
                  <div v-else>{{detailValue.memo}}</div>
                </el-form-item>
              </el-col>
              <el-col v-if="detailValue.state == '拒绝'" :span="24">
                <el-form-item label="驳回原因：" prop="">
                  <div>{{detailValue.auditReason}}元</div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row v-if="title=='退预交金'">
              <el-col :span="6">
                <el-form-item label="预交金额：" prop="">{{info.amount}}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="收款方式：" prop="">{{info.payWay | dictText('PayWay')}}</el-form-item>
              </el-col>
              
               <el-col :span="6">
                <el-form-item label="交款人：" prop="">{{info.payerName}}</el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="联系方式：" prop="contact">{{info.payerPhone}}</el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="退款方式：" prop="payType">
                  <el-select class="" v-model="detailValue.payType" placeholder="请选择退款方式" size="small">
                    <dict-select dict-type="refundType" placeholder="请选择退款方式" style="width: auto" isEnum></dict-select>

                    <!-- <el-option v-for="(item, index) in getDict('Dept')" :key="index" :label="item.text" :value="item.code"></el-option> -->
                    <!-- <el-option v-for="(item, index) in [{text:'原渠道返回',code:'FH'},{text:'现金',code:'XJ'}]" :key="index" :label="item.text" :value="item.code"></el-option> -->
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <div v-if="title=='欠账审批'">
              <el-row>
                <el-col :span="24">
                  <el-form-item label="不交押金：" prop="">
                    <el-checkbox v-model="detailValue.checkedQZ" :disabled="true"></el-checkbox>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item label="欠账额度：" prop="">{{detailValue.qzAmount}}元</el-form-item>
                </el-col>
                
                <el-col :span="12">
                  <el-form-item label="欠账截止日期：" prop="">{{detailValue.qzEndDate}}</el-form-item>
                </el-col>
                <el-col :span="24">
                  <el-form-item label="备注：" prop="contact">{{detailValue.memo}}</el-form-item>
                </el-col>
              </el-row>
              <el-divider></el-divider>
              <el-descriptions title="审批"></el-descriptions>
              <el-row>
                <el-col :span="24">
                  <el-form-item label="驳回原因：" prop="">
                    <el-input type="textarea" style="width:30rem;" maxlength="500" show-word-limit :autosize="{ minRows: 3, maxRows: 4}" placeholder="请输入驳回原因" v-model="reason">
                  </el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </el-form>
          
        </div>
        <el-row style="margin-top: 20px; text-align: right">
          <el-button  size="large" class="w100" @click.native="$emit('update:visible', false)">关闭</el-button>
          <el-button v-if="title=='欠账审批'" size="large" class="w100" @click="approve(false)">驳回</el-button>
          <el-button v-if="title=='欠账审批'" @click.native="approve(true)" class="w100" type="primary" size="large">批准</el-button>

          <el-button v-if="title=='欠账编辑'"  size="large" class="w100" @click.native="submit('save')">保存</el-button>
          <el-button v-if="title=='欠账编辑'||title=='退预交金'" @click.native="submit('submit')" class="w100" type="primary" style="margin-left: 1rem" size="large">提交</el-button>
            <br/>
            <br/>
            <el-checkbox v-if="title=='退预交金'" v-model="checked">打印凭据</el-checkbox>
        </el-row>
      </div>
    </el-main>
  </el-dialog>
</template>

<script>
import api from "./api";
import { mapGetters } from "sw-hic";
export default {
  components: {
    // comContent: () => import("./content"),
    // selectorStaff: () => import("@/components/_com/selectorStaff"),
  },
  props: {
    title:String,
    info:Object,
    visible: Boolean,
    isNew: Boolean,
  },
  data() {
    var checkFloat = (rule, value, callback) => {
      let frex = /^[0-9]+\.?[0-9]*$/;
      if (!value) return callback();
      if (!frex.test(value)) {
        callback(new Error("请输入数字"));
      } else {
        callback();
      }
    };
    return {
      patient:{},
      reason:'',
      checked:false,
      detailValue:{},
      conTitle:'',
      meta:{
        loading:false
      },
      rules: {
        payType: [
          { required: true, message: "请选择退款方式", trigger: "change" },
        ],
        qzAmount:[{ required: true, message: "请输入可欠账额度", trigger: "blur" },
        { validator: checkFloat, trigger: "blur" }],
        qzEndDate:[{ required: true, message: "请选择欠账截止日期", trigger: "change" }]
      },
    };
  },
  computed: {
    ...mapGetters(["dict", , "Enum", "dictEnum","user", "permission"]),
    nowTime() {
      return new Date(); //this.$utils.fmtDateTime(new Date())
    },
  },
  filters:{
   
  },
  watch:{
  },
  mounted() {
    // this.getPatient()
   
    switch(this.title){
      case '预交金记录':
        this.conTitle = '历史记录'
        this.patient = this.info
        break
      case '退预交金':
        this.conTitle = '预交金详情'
        this.getPatient()
        break
      case '欠账编辑':
      case '欠账详情':
        this.conTitle = '欠账申请'
        this.init()
        break
      case '欠账审批':
        this.conTitle = '欠账审批'
        this.init()
        break
    }
    
  },
  methods: {
    init(){
      this.detailValue = {
        checkedQZ:this.info.noDeposit,
        qzAmount:this.info.amount,
        qzEndDate:this.info.endDate,
        memo:this.info.proposeReason
      }
      this.getPatient()
    },
    getPatient(){
      api.getAdmission({ipNo:this.info.ipNo}).then(res=>{
        this.patient = res.items[0]
      }).catch(error=>{

      }).finally(()=>{
        this.meta.loading = false;
      })
    },
    
    cancel() {
      this.$emit("update:visible", false);
    },
    submit(type){
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.meta.loading = true
          if(this.title == '退预交金'){
            api.refundPayment(this.info.id).then((res)=>{
              this.$message.success("退费成功")
              this.$emit("close");
              this.cancel()
            }).catch((err)=>{
              this.$message.error(err.message || err);
            }).finally(()=>{
              this.meta.loading = false;
            }) 
          }
          if(this.title == '欠账编辑'){
            this.editQZ(type)
          }
         
        } else {
          
          return false;
        }
      })
    },
    //编辑申请、需要先获取现有的值，在把需要修改的值改了，最后调用put修改
    async editQZ(type){
      this.meta.loading = true
      let qzInfo = await api.getArrearageById(this.info.id)
      qzInfo.noDeposit = this.detailValue.checkedQZ
      qzInfo.amount = this.detailValue.qzAmount
      qzInfo.endDate = this.$utils.Fmt.fmtDateTime(this.detailValue.qzEndDate)
      qzInfo.proposeReason = this.detailValue.memo
      qzInfo.state = (type == 'save') ? 0 : 1 //草稿、审批中、通过、拒绝
      this.updateQZ(qzInfo)
    },
    //审批时、需要先获取现有的值，然后修改状态，最后调用put修改
    async approve(type){//false-驳回，true-批准
      this.meta.loading = true
      let qzInfo = await api.getArrearageById(this.info.id)
      if(!type && !this.reason){
        return this.$message.error('请输入驳回原因')
      }
      qzInfo.auditReason = this.reason
      qzInfo.auditorId = this.user.id
      qzInfo.auditorName = this.user.name
      qzInfo.auditTime = this.$utils.Fmt.fmtDateTime(new Date().getTime())
      qzInfo.state = type ? 2 : 3 //草稿、审批中、通过、拒绝
      this.updateQZ(qzInfo)
    },
    async updateQZ(qzInfo){
      let result = await api.editArrearage(qzInfo,this.info.id)
      if(result){
        this.$message.success('操作成功')
        this.$emit("close");
        this.cancel()
      }else{
        this.$message.error('操作失败')
      }
      this.meta.loading = false
    }
  },
  beforeRouteLeave (to,from, next) {
    return next();
  }
};
</script>

<style scoped>
.redaK{
  background-color: #909399;
}
.tx-r{
  text-align: right;
}

.tx-l{
  text-align: left;
}
.tx-c{
  text-align: center;
}
.pall10p{
  padding: 10px;
}


.patientBox {
  height: 5rem;
  margin-bottom: 2rem;
}

.el-row {
  margin-bottom: 10px;
}

.el-row:last-child {
  margin-bottom: 0px;
}

.ztitle {
  margin-top: 10px;
  color: #66b1ff;
}
.inputnw .el-input {
  width: 4rem !important;
}
.inputDelW {
  width: 12rem;
}
.el-form--inline .el-form-item{
  margin-right: 0px;
}


</style>
<style>
.nobd .el-table__cell{
  border-right: none !important;
}
</style>
